module.exports = __webpack_public_path__ + "img/caret-down.c29bd32f.svg";